import SwitchButton from 'LuxKit/Switch/SwitchButton'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { ChangeEventHandler, useCallback } from 'react'
import { isSpoofed } from 'selectors/featuresSelectors'
import LuxPlusLogo from './Logos/LuxPlusLogo'

interface Props {
  displayMemberPrice: boolean
  offer: App.AnyOffer
  isSpoofed: boolean
}

function OfferCalendarLuxPlusToggle({ displayMemberPrice, offer, isSpoofed }: Props) {
  const dispatch = useOfferPageDispatch()

  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>((event) => {
    dispatch({ type: OfferPageActions.setDisplayMemberPrice, displayMemberPrice: event.currentTarget.checked })
  }, [dispatch])

  if (offer.luxPlus.access === 'memberOnly' && !isSpoofed) {
    return null
  }

  return <ProductPaletteProvider palette="lux-plus">
    <SwitchButton
      checked={displayMemberPrice}
      data-testid="memberPrice-toggle"
      onChange={handleChange}
    >
      <LuxPlusLogo inline height={10} />
    </SwitchButton>
  </ProductPaletteProvider>
}

export default withOfferPageAndReduxState((state, appState) => ({
  displayMemberPrice: !!state.displayMemberPrice,
  offer: state.offer ?? state.tourV2Offer,
  isSpoofed: isSpoofed(appState),
}), OfferCalendarLuxPlusToggle)
